<p-dialog
  [(visible)]="visible"
  (visibleChange)="onVisibleChange($event)"
  [modal]="true"
  [style]="{ width: '80vw', maxWidth: '900px' }"
  [draggable]="false"
  [resizable]="false"
  [closable]="false">
  
  <ng-template pTemplate="header">
    <div class="flex items-center justify-between w-full">
      <h2 class="text-xl font-semibold m-0" style="color: hsl(var(--text));">
        Vincular anunciante
      </h2>
      <button 
        pButton 
        type="button"
        icon="pi pi-times"
        class="p-button-text p-button-rounded p-button-plain"
        (click)="onVisibleChange(false)">
      </button>
    </div>
  </ng-template>
  
  <div class="dialog-content">
    <!-- Tabs -->
    <div class="tabs-container">
      <div class="tabs-header">
        <button
          type="button"
          class="tab-button"
          [class.active]="selectedTab() === 'libres'"
          (click)="onTabChange('libres')">
          Libres
        </button>
        <button
          type="button"
          class="tab-button"
          [class.active]="selectedTab() === 'todos'"
          (click)="onTabChange('todos')">
          Todos
        </button>
      </div>

      <div class="tab-content">
        <!-- Buscador -->
        <div class="search-wrapper">
          <span class="p-input-icon-left w-full">
            <i class="pi pi-search"></i>
            <input 
              pInputText 
              type="text" 
              placeholder="Buscar anunciantes..."
              [value]="filterValue()"
              (input)="onSearchInput($event)"
              class="w-full" />
          </span>
        </div>

        <!-- Tabla -->
        <div class="table-wrapper">
          @if (loading()) {
            <div class="loading-state">
              <i class="pi pi-spin pi-spinner text-2xl" style="color: hsl(var(--muted));"></i>
              <p class="text-sm mt-2" style="color: hsl(var(--muted));">Cargando anunciantes...</p>
            </div>
          } @else {
            <p-table
              #dt
              [value]="anunciantes()"
              [lazy]="true"
              [loading]="loading()"
              [totalRecords]="totalRecords()"
              [rows]="nroFilasPorPagina"
              [rowsPerPageOptions]="[10, 20, 30]"
              [paginator]="true"
              [sortMode]="'single'"
              (onLazyLoad)="onLazyLoad($event)"
              [globalFilterFields]="['razonSocial', 'nombreFantasia', 'cuit', 'email']"
              styleClass="p-datatable-sm p-datatable-compact"
              [tableStyle]="{'min-width': '50rem'}">
              
              <ng-template pTemplate="header">
                <tr>
                  <th pSortableColumn="razonSocial" style="width: 30%">
                    Razón Social
                    <p-sortIcon field="razonSocial"></p-sortIcon>
                  </th>
                  <th pSortableColumn="cuit" style="width: 20%">
                    CUIT
                    <p-sortIcon field="cuit"></p-sortIcon>
                  </th>
                  <th pSortableColumn="email" style="width: 25%">
                    Email
                    <p-sortIcon field="email"></p-sortIcon>
                  </th>
                  <th style="width: 25%">Acción</th>
                </tr>
              </ng-template>

              <ng-template pTemplate="body" let-anunciante>
                <tr>
                  <td>
                    <div class="font-medium">{{ anunciante.razonSocial }}</div>
                    @if (anunciante.nombreFantasia) {
                      <div class="text-sm" style="color: hsl(var(--muted));">{{ anunciante.nombreFantasia }}</div>
                    }
                  </td>
                  <td>{{ anunciante.cuit || '-' }}</td>
                  <td>{{ anunciante.email || '-' }}</td>
                  <td>
                    <button 
                      pButton 
                      type="button"
                      label="Vincular"
                      icon="pi pi-link"
                      class="p-button-sm p-button-outlined"
                      [disabled]="!canLink(anunciante)"
                      (click)="linkAnunciante(anunciante)">
                    </button>
                  </td>
                </tr>
              </ng-template>

              <ng-template pTemplate="emptymessage">
                <tr>
                  <td colspan="4" class="empty-state">
                    <div class="flex flex-col items-center gap-2">
                      <i class="pi pi-inbox text-4xl" style="color: hsl(var(--muted));"></i>
                      <p style="color: hsl(var(--muted));">No se encontraron anunciantes</p>
                      <p class="text-xs" style="color: hsl(var(--muted));">Intenta con otros términos de búsqueda</p>
                    </div>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          }
        </div>
      </div>
    </div>
  </div>

</p-dialog>

